<template>
  <div id="app">
    <EventsCalendar />
  </div>
</template>

<script>
import EventsCalendar from './components/EventsCalendar.vue'

export default {
  name: 'App',
  components: {
    EventsCalendar
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap');

*{
  margin: 0px;
  padding: 0px;

}

body{
  font-family: 'Open Sans', sans-serif;
  //background: #212121;
}
::-webkit-scrollbar-button {
  background-image: url("");
  background-repeat: no-repeat;
  width: 6px;
  height: 0px; }

::-webkit-scrollbar-track {
  background-color: black;
  box-shadow: 0px 0px 0px #000 inset; }

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  background-color: #9e238e; }

::-webkit-resizer {
  background-image: url("");
  background-repeat: no-repeat;
  width: 7px;
  height: 0px; }

::-webkit-scrollbar {
  width: 6px; }
</style>
